// extracted by mini-css-extract-plugin
export default {"icon":"styles-module--icon--032a4"};